import { render, staticRenderFns } from "./shopConfig.vue?vue&type=template&id=542bab64&scoped=true"
import script from "./shopConfig.vue?vue&type=script&lang=js"
export * from "./shopConfig.vue?vue&type=script&lang=js"
import style0 from "./shopConfig.vue?vue&type=style&index=0&id=542bab64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542bab64",
  null
  
)

export default component.exports